import React from 'react';
import { TimeRangePicker } from '../../../shared';
import { View } from '@amzn/atoz-web/View';
import { FormWrapper } from '@amzn/atoz-web/FormWrapper';
export var ShiftTimeFilter = function (_a) {
    var onShiftTimeStartChange = _a.onShiftTimeStartChange, onShiftTimeEndChange = _a.onShiftTimeEndChange, filterState = _a.filterState;
    return (React.createElement(View, { dataTestId: "time-filters" },
        React.createElement(FormWrapper, null,
            React.createElement(TimeRangePicker, { setRangeStart: onShiftTimeStartChange, setRangeEnd: onShiftTimeEndChange, startTime: filterState.startTime, endTime: filterState.endTime }))));
};
